module.exports = __webpack_public_path__ + "static/media/admin-dashboard.fcbb0f1f.png";